import { Component, computed, effect, ElementRef, input, inject, signal, viewChild, output } from '@angular/core';
import { FormElementDirective, FormElementSize, injectNgControl } from '../form-element.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { IconComponent } from '../../icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'topo-search-input',
  hostDirectives: [FormElementDirective],
  imports: [ReactiveFormsModule, IconComponent, NgClass],
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss'
})
export class SearchInputComponent extends FormElementDirective {
  protected ngControl = injectNgControl();

  placeholder = input<string>('');
  onSearchClicked = output<string>();
  protected expanded = signal(false);
  protected inputEl = viewChild('searchInput', { read: ElementRef<HTMLInputElement> });
  protected formElDir = inject(FormElementDirective, { self: true });

  protected sizeValue = computed(() => {
    switch (this.size()) {
      case FormElementSize.Small:
        return '2rem';
      case FormElementSize.Large:
        return '3rem';
      case FormElementSize.Medium:
      default:
        return '2.5rem';
    }
  });

  focusEffect = effect(() => {
    const isExpanded = this.expanded();
    const inputEl = this.inputEl();

    if (isExpanded && !!inputEl) {
      inputEl.nativeElement.focus();
    }
  });

  expandControl(event: Event): void {
    event.stopPropagation();
    this.expanded.set(true);
  }

  collapseControl(event: Event): void {
    event.stopPropagation();
    this.expanded.set(false);
    this.ngControl.control.setValue(null);
  }
}
